import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getAdvertiserHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/advertiser/_layout/request/_layout/payout/"
)({
    component: AdvertiserPayoutsRequestsPage,
    staticData: {
        permissions: [PermissionEnum.AdvertiserPayoutView],
        showInSideMenu: false,
        label: "pages.advertiser.request.payout.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.advertiser.request.payout.title"),
        };
    },
});

function AdvertiserPayoutsRequestsPage() {
    return (
        <TenantPage headerNavigationItems={getAdvertiserHeaderItems}>
            <></>
        </TenantPage>
    );
}
